module.exports = __webpack_public_path__ + "img/div-01.7c3b5aa5.png";